export default __webpack_public_path__ + "static/media/man_in_the_wind_2.85a5a657.png";